<template>
    <div class="content" v-show="show">
        <div class="mask"></div>
        <div class="box">
            <div class="box-top">
                <span class="box-title">告警统计</span>
                <div class="top-btn">
                    <img alt src="../../assets/img/common/close.png"  @click="close"/>
                </div>
            </div>
            <div class="box-content">
                <div class="v1">
                    <div class="v101">
                        <span>时间范围：</span>
                        <el-date-picker v-model="value2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="截止日期" format="yyyy-MM-dd" style="width: 260px;">
                        </el-date-picker>
                    </div>
                    <div class="v102">
                        <span class="btn1" @click="queryDataList">查询统计</span>
                    </div>
                </div>
                <div class="v2">
                    <div v-for="(item, i) in warnTypeRankList" :key="i" class="card">
                        <span class="title">{{ item.rankName }}</span>
                        <span class="num" v-if="item.num==0">{{ item.num }}次</span>
                        <span class="num" v-else style="font-weight: bold; color: orangered">{{ item.num }}次</span>
                    </div>
                </div>
                <div ref="chartRef" style="width: 1000px; height: 300px; background-color: #FFFFFF;"></div>
            </div>
        </div>

    </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts';
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
]);

export default {
    inject: ['app'],
    components: {
    },
    data() {
        return {
            activeName: 'first',
            chart: undefined,
            chartOption: {
                title: {
                    text: '船舶告警排行榜'
                },
                tooltip: {},
                xAxis: {
                    name: '船舶名称',
                    data: [],
                    axisLabel: {
                        rotate: 45,   // 旋转45度
                        margin: 10    // 调整边距避免重叠
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '告警次数',
                },
                series: [{
                    name: '告警次数',
                    type: 'bar',
                    data: [],
                    smooth: true,
                    itemStyle: {
                        color: '#FF6333'
                    }
                }],
                
            },
            warnTypeRankList: [],
            value2: [],
        }
    },
    computed: {
        hasLogin(){
            return this.$store.state.hasLogin
        },
        show(){
            return this.$store.state.showWarnStat
        }
    },
    watch: {
        show(newVal, oldVal){
            if(newVal){
                this.$nextTick(() => {
                    this.initChart();
                    this.resetForm()
                    this.queryDataList()
                });
            }
        }
    },
    methods: {

        initChart(){
            this.chart = echarts.init(this.$refs.chartRef)
        },

        close(){
            if(this.chart!=null && this.chart.dispose){
                this.chart.dispose()
            }
            this.$store.commit('updateShowBySrc', {src: 'warnStat', val: 0})
        },

        queryDataList(){
            let p = {
                agentId: localStorage.getItem('login_agent_id')
            }
            if(this.value2 && this.value2.length>0){
                p.beginTime = this.parseTime(this.value2[0], '{y}-{m}-{d} 00:00:00')
                p.endTime = this.parseTime(this.value2[1], '{y}-{m}-{d} 23:59:59')
            }else{
                p.beginTime = this.parseTime(new Date(), '{y}-{m}-{d} 00:00:00')
                p.endTime = this.parseTime(new Date(), '{y}-{m}-{d} 23:59:59')
            }
            this.sswgPost('/warn/statWarnReport', p).then(res => {
                console.log(res)
                if(res.code==200){
                    this.convertData(res.data)
                }
            })
        },

        convertData(data){
            this.warnTypeRankList = data.warnTypeRankList
            // 转换店铺告警排行榜
            let merchantRankList = data.merchantRankList
            let merchantNameArr = []
            for(let i=0; i<merchantRankList.length; i++){
                merchantNameArr.push(merchantRankList[i].rankName)
                // 填充value值
                merchantRankList[i].value = merchantRankList[i].num
            }
            this.chartOption.xAxis.data = merchantNameArr
            this.chartOption.series[0].data = merchantRankList
            this.chart.setOption(this.chartOption)
            // 绑定点击事件
            this.chart.on('click', params => {
                // console.log('点击参数:', params)
                this.handleChartClick(params.data)
            })

        },

        // 点击柱状图事件
        handleChartClick(data) {
            this.$store.commit('updateShowWarnList', 9)
            // console.log(data)
            this.app.updateWarnSerachParam(this.value2, data.merchantId)

            

            // 获取点击数据
            // this.clickData = {
            //     name: params.name,
            //     value: params.value,
            //     series: params.seriesName
            // }
            
            // 可以在这里添加业务逻辑
            // this.$emit('chart-click', params) // 触发父组件事件
        },

        resetForm(){
            var currentDate = new Date(); // 获取当前时间
            currentDate.setMonth(currentDate.getMonth() - 1); // 减去一个月
            this.value2 = [currentDate, new Date()]
        },

    }
}

</script>

<style lang="scss" scoped>
    .content {
        width: 100%;
        height: 100%; 
        position: fixed; 
        z-index: 190; 
        .mask {
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 180;
            opacity: 0.4;
            background-color: #74b1d1;
        }
        .box {
            position: fixed;
            left: 50%;
            top: 45%;
            background-color: #0078d7;
            border-radius: 5px;
            transform: translate(-50%,-50%);
            border: 1px solid #5d6359;
            z-index: 210;
            color: #ffffff;
            .box-top {
                height: 32px;
                text-align: center;
                position: relative;
                .box-title {
                    font-weight: bold;
                    line-height: 30px;
                    font-size: 15px;
                    user-select: none;
                }
                .top-btn {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    user-select: none;
                    img {
                        cursor: pointer;
                    }
                }
            }
            .v1 {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 10px 12px 10px;
                
                .btn1 {
                    font-size: 14px;
                    height: 24px;
                    line-height: 24px;
                    padding: 4px 10px;
                    background: linear-gradient(to bottom, #8ec8f1, #b9dffb);
                    margin-left: 20px;
                    color: #000;
                    border-radius: 4px;
                    cursor: pointer;
                    user-select: none;
                }
            }

            .v2 {
                width: 1000px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: flex-start;
                border-top: 1px dashed #FFFFFF;
                padding-bottom: 10px;
                padding-top: 10px;
                .card {
                    width: 132px;
                    height: 50px;
                    background-color: #9fcacf;
                    background: linear-gradient(to right,#48a2f7, #a9c8f7);
                    border-radius: 4px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 4px;
                    color: #000;
                    font-size: 15px;
                    font-weight: 400;
                    padding: 0 6px;
                    font-family: "Microsoft Yahei";
                    box-shadow: inset -1px -1px 1px #9bcefd;
                }
            }

            .box-content {
                border: 1px solid #FFFFFF;
                border-radius: 0 0 4px 4px;
                padding: 4px 4px;
                
            }
           
        }
    }
</style>
<style scoped>
    .v101 >>> .el-date-editor .el-range-input {
        height: 26px;
        background: none;
        font-size: 15px;
        font-weight: bold;
        color: #FFF;
    }

    .v101 >>> .el-date-editor .el-range-separator {
        height: 26px;
        line-height: 26px;
        color: #FFFFFF;
    }

    .v101 >>> input.el-input__inner {
        font-size: 15px;
        font-weight: bold;
        height: 26px;
        line-height: 26px;
        background: none;
        color: #FFFFFF;
    }
    .v101 >>> .el-input__icon {
        line-height: normal;
    }

    .v101 >>> .el-input__inner {
        background: none;
        height: 26px;
        line-height: 26px;
    }

</style>